import { useEffect, useState } from 'react';
import { WsSelect, WsSelectObj, BuildingTIcon } from 'wisestep-base';

import { useBusinessUnitContext } from '../../../context';
import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

const BusinessUnitFilter = ({ title, placeHolder, name, showAccordionIcon }: WsFilterProps) => {
  const [buList, setBUList] = useState<WsSelectObj[]>([]);
  const businessUnits = useBusinessUnitContext();
  useEffect(() => {
    const list = [{ label: 'All', value: 'all' }];
    const newOptions = businessUnits.map((bu) => ({
      label: bu.name ?? '',
      value: `${bu?.id} & ${bu.name}`,
    }));
    setBUList([...list, ...newOptions]);
  }, [businessUnits]);

  return (
    <WsAccordion
      title={title ?? 'Business Unit'}
      startIcon={showAccordionIcon ? <BuildingTIcon /> : null}
    >
      <WsSelect
        name={name}
        selectArray={buList}
        placeholder={
          buList
            ? placeHolder ?? 'Select business Unit'
            : 'No Business Units Available. Please Configure from Settings Page'
        }
        disabled={buList ? false : true}
        variant="outlined"
        size="small"
      />
    </WsAccordion>
  );
};
export default BusinessUnitFilter;
